<template>
  <div class="nav">
    <el-menu background-color="#fff"
             text-color="#191818"
             :default-active="defaultActive"
             style="height:100%"
             @open="handleOpen"
             @close="handleClose">
      <NavMenu :navMenus="menuData"></NavMenu>
    </el-menu>
  </div>
</template>

<script>
import NavMenu from "./NavItem";
export default {
  props: {
    menuData: Array
  },
  components: {
    NavMenu
  },
  computed: {
    defaultActive () {
      if (this.$route.query && this.$route.query.flag) {
        return this.$route.path + '?flag=' + this.$route.query.flag;
      }
      else return this.$route.path
    }
  },
  methods: {
    toHomeLink (key) {
      if (key === "/UC/User") this.$router.push("/UC/User");
    },

    handleOpen (key, keyPath) {
      this.toHomeLink(key);
    },

    handleClose (key) {
      this.toHomeLink(key);
    }

  }
};
</script>

<style scoped>
/* .nav {
  padding-left: 15px;
} */
</style>


